// style
import { css } from 'styled-components';

// 기본 버튼 사이즈
export const getSizeStyle = (size) => {
  switch (size) {
    case 'xsmall':
      return css`
        height: 24px;
        padding: 0 12px;
        font-size: 12px;
      `;
    case 'small':
      return css`
        height: 30px;
      `;
    case 'medium':
      return css`
        height: 34px;
      `;
    case 'middle':
      return css`
        width: 90px;
        font-size: 14px;
      `;
    case 'big':
      return css`
        width: 100px;
        font-size: 14px;
      `;
    case 'large':
      return css`
        height: 38px;
        font-size: 14px;
        padding: 0 18px;
      `;
    case 'xlarge':
      return css`
        font-size: 14px;
        height: 40px;
        padding: 0 24px;
      `;
    case 'default':
      return css`
        padding: 0 16px;
        font-size: 13px;
        font-weight: 400;
      `;
    default:
      return css`
        width: auto;
        height: auto;
      `;
  }
};
